var spriteIcons_default = [
  "arrow-right",
  "arrow-left",
  "arrow-right-long",
  "cart-shopping",
  "chevron-right",
  "download",
  "error",
  "error-image",
  "empty-cart",
  "heart",
  "heart-circle-check",
  "no-results",
  "plus",
  "xmark"
];
export {
  spriteIcons_default as default
};
